import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { showApiErrorToast } from '@/utils/errors';
import { createFeedbackType, feedbackTypeQueryKeys } from '../api/feedbackTypes.api';
import type { CreateFeedbackTypePayload } from '../types/feedbackType.types';

export function useCreateFeedbackType(onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: CreateFeedbackTypePayload) => createFeedbackType(payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: feedbackTypeQueryKeys.all() });
      toast.success('Feedback type created successfully');
      onSuccess?.();
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to create feedback type');
    },
  });
}
